import { render, staticRenderFns } from "./reserveDetail.vue?vue&type=template&id=592bc5a4&scoped=true&"
import script from "./reserveDetail.vue?vue&type=script&lang=js&"
export * from "./reserveDetail.vue?vue&type=script&lang=js&"
import style0 from "./reserveDetail.vue?vue&type=style&index=0&id=592bc5a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592bc5a4",
  null
  
)

export default component.exports